export const gtmEventTypes = {
  CLICK_SEARCH_ICON: 'FED-SEARCH-001',
  SITE_SEARCH_BAR_SEARCHED: 'FED-SEARCH-002',
  SITE_SEARCH_RESULTS: 'FED-SEARCH-003',
  SITE_SEARCH_RESULTS_CLICKED: 'FED-SEARCH-004',
}

export const gtmEvents = {
  [gtmEventTypes.CLICK_SEARCH_ICON]: ({pageName}) => ({
    type: gtmEventTypes.CLICK_SEARCH_ICON,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_SEARCH_ICON,
    pageCategory: 'Site Search Bar',
    pageAction: `Site Search Bar - Search icon clicked on ${pageName} page`,
  }),
  [gtmEventTypes.SITE_SEARCH_BAR_SEARCHED]: ({query}) => ({
    type: gtmEventTypes.SITE_SEARCH_BAR_SEARCHED,
    event: 'reactjs.event',
    eventID: gtmEventTypes.SITE_SEARCH_BAR_SEARCHED,
    pageCategory: 'Site Search Bar',
    pageAction: `Site Search Bar - Searched "${query}"`,
  }),
  [gtmEventTypes.SITE_SEARCH_RESULTS]: ({query}) => ({
    type: gtmEventTypes.SITE_SEARCH_RESULTS,
    event: 'reactjs.event',
    eventID: gtmEventTypes.SITE_SEARCH_RESULTS,
    pageCategory: 'Site Search Results',
    pageAction: `Site Search Results - Searched "${query}"`,
  }),
  [gtmEventTypes.SITE_SEARCH_RESULTS_CLICKED]: ({query, clicked}) => ({
    type: gtmEventTypes.SITE_SEARCH_RESULTS_CLICKED,
    event: 'reactjs.event',
    eventID: gtmEventTypes.SITE_SEARCH_RESULTS_CLICKED,
    pageCategory: 'Site Search Results',
    pageAction: `Site Search Results - Searched "${query}" and clicked "${clicked}"`,
  }),
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/search-duck.js